import React, { FC } from 'react';
import { useTranslation } from '../../services';
import { Button, Grid, InputAdornment, Stack, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { addResponsiblePersonValidationSchema } from './addResponsiblePerson.validation.schema';
import styles from '../StudyRequestForm/StudyRequestForm.module.css';
import EmailIcon from '@mui/icons-material/Email';
import { Send } from '@mui/icons-material';

interface AddResponsiblePersonFormInterface {
	onSubmit: (props: any) => void;
}

const AddResponsiblePersonForm: FC<AddResponsiblePersonFormInterface> = ({
	onSubmit,
}) => {
	const { t } = useTranslation();
	const {
		control,
		formState: { errors },
		handleSubmit,
	} = useForm({
		mode: 'onTouched',
		defaultValues: { email: '' },
		resolver: yupResolver(addResponsiblePersonValidationSchema),
	});

	return (
		<form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<Controller
						name="email"
						control={control}
						render={({ field }) => (
							<TextField
								required
								error={!!errors.email}
								helperText={t(errors.email?.message || '')}
								className={styles.fullWidth}
								variant="outlined"
								label={t('Email')}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<EmailIcon />
										</InputAdornment>
									),
								}}
								{...field}
							/>
						)}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<Stack direction="row" spacing={2}>
						<Button type="submit" variant="contained" startIcon={<Send />}>
							{t('Send')}
						</Button>
					</Stack>
				</Grid>
			</Grid>
		</form>
	);
};

export default AddResponsiblePersonForm;
